module.exports = __webpack_public_path__ + "img/no.b7a21f54.svg";